import {
  Component,
  Input,
  ElementRef,
  ViewChild,
  OnInit,
  Output,
  EventEmitter,
  ViewEncapsulation,
} from '@angular/core';
import { InlineFieldInterfaceComponent } from '../inline-field-interface.component';
import { PartialFormField } from '../../form-fields/form-field.types';
import unformat from 'accounting-js/lib/unformat.js';
import isNull from 'lodash-es/isNull';
import UrlUtils from 'app/shared/Utils/url.utils';

@Component({
  templateUrl: './number-inline-field.component.html',
  styleUrls: ['./number-inline-field.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class NumberInlineFieldComponent implements InlineFieldInterfaceComponent, OnInit {
  @ViewChild('inputEditorControl') inputEditorControl: ElementRef;

  @Input() model: any;
  @Input() fieldDef: any;
  @Input() data: any;
  @Input() excludeLabels: boolean = false;
  @Input() readonly: boolean = false;
  @Input() showEmptyHolder: boolean = false;
  @Input() canClick: boolean = false;
  @Output() onClick: EventEmitter<PartialFormField> = new EventEmitter();
  @Output() update: EventEmitter<PartialFormField> = new EventEmitter();

  public value: string = '';
  public editing: boolean = false;
  public showTip: string;
  private _originalValue;
  public emptyCellOverlay;
  precision: number = 0;

  ngOnInit() {
    this.value = this.fieldDef.meta?.value_hidden ? 'REDACTED' : this.model[this.fieldDef.name];
    this.emptyCellOverlay = this.showEmptyHolder && isNull(this.value);
    this._originalValue = this.value;
    this.showTip = this.fieldDef.meta?.calc_code;
    if (this.fieldDef.meta && this.fieldDef.meta.readonly) {
      this.readonly = this.fieldDef.meta.readonly;
    }
    if (this.fieldDef.meta && this.fieldDef.meta.scale !== null) {
      this.precision = this.fieldDef.meta.scale;
    }
  }

  edit() {
    if (!this.editing && !this.readonly) {
      this.editing = true;
      setTimeout(() => {
        this.inputEditorControl.nativeElement.focus();
      }, 100);
    }
  }

  onBlur($event: Event) {
    this.editing = false;
    this.value = UrlUtils.checkAndEvalFormula(this.value)?.toString();
    if (this._originalValue != this.value) {
      this.updateModel();
      this.update.emit({ [this.fieldDef.name]: unformat(this.value) });
    }
  }

  updateModel() {
    this.model[this.fieldDef.name] = unformat(this.value);
    this._originalValue = this.value;
    this.emptyCellOverlay = this.showEmptyHolder && isNull(this.value);
  }

  clickField($event) {
    this.onClick.emit($event);
  }
}
